import { createContext, type Context } from 'react';

import { type ShowStoreErrorFlag } from './StoreErrorFlagId';

const StoreErrorFlagContext: Context<ShowStoreErrorFlag | undefined> = createContext<
	ShowStoreErrorFlag | undefined
>(undefined);

export default StoreErrorFlagContext;
